export default __webpack_public_path__ + "static/media/J724_SOV.0d578c1d.pdf";